"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/cms_common.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSAccountEvents = exports.CMSAccountGoods = exports.CMSAccountPlan = exports.CMSAccountCoreFan = exports.CMSAccountPurchasedEventTickets = exports.CMSAccountPurchasedGoods = exports.CMSAccountSubscribedPlan = exports.CMSAccountFan = exports.CorporationTenantInfo = exports.IndividualTenantInfo = exports.CMSTenantCore = exports.CMSTenant = exports.CMSBrandCore = exports.CMSBrand = exports.CMSCreatorCore = exports.CMSCreator = exports.CMSAccountCoreFansListDurationOrder = exports.CMSCoreFansPlanFilterCondition = exports.CMSTenantType = exports.CMSCreatorRole = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.account.v1.CMSCreatorRole
 */
var CMSCreatorRole;
(function (CMSCreatorRole) {
    /**
     * @generated from enum value: CMS_CREATOR_ROLE_UNSPECIFIED = 0;
     */
    CMSCreatorRole[CMSCreatorRole["CMS_CREATOR_ROLE_UNSPECIFIED"] = 0] = "CMS_CREATOR_ROLE_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_CREATOR_ROLE_ADMIN = 1;
     */
    CMSCreatorRole[CMSCreatorRole["CMS_CREATOR_ROLE_ADMIN"] = 1] = "CMS_CREATOR_ROLE_ADMIN";
    /**
     * @generated from enum value: CMS_CREATOR_ROLE_OWNER = 2;
     */
    CMSCreatorRole[CMSCreatorRole["CMS_CREATOR_ROLE_OWNER"] = 2] = "CMS_CREATOR_ROLE_OWNER";
    /**
     * @generated from enum value: CMS_CREATOR_ROLE_OPERATOR = 3;
     */
    CMSCreatorRole[CMSCreatorRole["CMS_CREATOR_ROLE_OPERATOR"] = 3] = "CMS_CREATOR_ROLE_OPERATOR";
})(CMSCreatorRole = exports.CMSCreatorRole || (exports.CMSCreatorRole = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSCreatorRole)
protobuf_1.proto3.util.setEnumType(CMSCreatorRole, "spwn.account.v1.CMSCreatorRole", [
    { no: 0, name: "CMS_CREATOR_ROLE_UNSPECIFIED" },
    { no: 1, name: "CMS_CREATOR_ROLE_ADMIN" },
    { no: 2, name: "CMS_CREATOR_ROLE_OWNER" },
    { no: 3, name: "CMS_CREATOR_ROLE_OPERATOR" },
]);
/**
 * @generated from enum spwn.account.v1.CMSTenantType
 */
var CMSTenantType;
(function (CMSTenantType) {
    /**
     * @generated from enum value: CMS_TENANT_TYPE_UNSPECIFIED = 0;
     */
    CMSTenantType[CMSTenantType["CMS_TENANT_TYPE_UNSPECIFIED"] = 0] = "CMS_TENANT_TYPE_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_TENANT_TYPE_INDIVIDUAL = 1;
     */
    CMSTenantType[CMSTenantType["CMS_TENANT_TYPE_INDIVIDUAL"] = 1] = "CMS_TENANT_TYPE_INDIVIDUAL";
    /**
     * @generated from enum value: CMS_TENANT_TYPE_CORPORATION = 2;
     */
    CMSTenantType[CMSTenantType["CMS_TENANT_TYPE_CORPORATION"] = 2] = "CMS_TENANT_TYPE_CORPORATION";
})(CMSTenantType = exports.CMSTenantType || (exports.CMSTenantType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSTenantType)
protobuf_1.proto3.util.setEnumType(CMSTenantType, "spwn.account.v1.CMSTenantType", [
    { no: 0, name: "CMS_TENANT_TYPE_UNSPECIFIED" },
    { no: 1, name: "CMS_TENANT_TYPE_INDIVIDUAL" },
    { no: 2, name: "CMS_TENANT_TYPE_CORPORATION" },
]);
/**
 * @generated from enum spwn.account.v1.CMSCoreFansPlanFilterCondition
 */
var CMSCoreFansPlanFilterCondition;
(function (CMSCoreFansPlanFilterCondition) {
    /**
     * @generated from enum value: CMS_CORE_FANS_PLAN_FILTER_CONDITION_UNSPECIFIED = 0;
     */
    CMSCoreFansPlanFilterCondition[CMSCoreFansPlanFilterCondition["CMS_CORE_FANS_PLAN_FILTER_CONDITION_UNSPECIFIED"] = 0] = "CMS_CORE_FANS_PLAN_FILTER_CONDITION_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_CORE_FANS_PLAN_FILTER_CONDITION_EQUAL = 1;
     */
    CMSCoreFansPlanFilterCondition[CMSCoreFansPlanFilterCondition["CMS_CORE_FANS_PLAN_FILTER_CONDITION_EQUAL"] = 1] = "CMS_CORE_FANS_PLAN_FILTER_CONDITION_EQUAL";
    /**
     * @generated from enum value: CMS_CORE_FANS_PLAN_FILTER_CONDITION_MORE_THAN = 2;
     */
    CMSCoreFansPlanFilterCondition[CMSCoreFansPlanFilterCondition["CMS_CORE_FANS_PLAN_FILTER_CONDITION_MORE_THAN"] = 2] = "CMS_CORE_FANS_PLAN_FILTER_CONDITION_MORE_THAN";
    /**
     * @generated from enum value: CMS_CORE_FANS_PLAN_FILTER_CONDITION_LESS_THAN = 3;
     */
    CMSCoreFansPlanFilterCondition[CMSCoreFansPlanFilterCondition["CMS_CORE_FANS_PLAN_FILTER_CONDITION_LESS_THAN"] = 3] = "CMS_CORE_FANS_PLAN_FILTER_CONDITION_LESS_THAN";
})(CMSCoreFansPlanFilterCondition = exports.CMSCoreFansPlanFilterCondition || (exports.CMSCoreFansPlanFilterCondition = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSCoreFansPlanFilterCondition)
protobuf_1.proto3.util.setEnumType(CMSCoreFansPlanFilterCondition, "spwn.account.v1.CMSCoreFansPlanFilterCondition", [
    { no: 0, name: "CMS_CORE_FANS_PLAN_FILTER_CONDITION_UNSPECIFIED" },
    { no: 1, name: "CMS_CORE_FANS_PLAN_FILTER_CONDITION_EQUAL" },
    { no: 2, name: "CMS_CORE_FANS_PLAN_FILTER_CONDITION_MORE_THAN" },
    { no: 3, name: "CMS_CORE_FANS_PLAN_FILTER_CONDITION_LESS_THAN" },
]);
/**
 * coreFanの一覧を取得する際に、planの継続期間が長い順 or 短い順にするかを制御する
 *
 * @generated from enum spwn.account.v1.CMSAccountCoreFansListDurationOrder
 */
var CMSAccountCoreFansListDurationOrder;
(function (CMSAccountCoreFansListDurationOrder) {
    /**
     * @generated from enum value: CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_UNSPECIFIED = 0;
     */
    CMSAccountCoreFansListDurationOrder[CMSAccountCoreFansListDurationOrder["CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_UNSPECIFIED"] = 0] = "CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_UNSPECIFIED";
    /**
     * 継続期間 短い順
     *
     * @generated from enum value: CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_ASC = 1;
     */
    CMSAccountCoreFansListDurationOrder[CMSAccountCoreFansListDurationOrder["CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_ASC"] = 1] = "CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_ASC";
    /**
     * 継続期間 長い順
     *
     * @generated from enum value: CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_DESC = 2;
     */
    CMSAccountCoreFansListDurationOrder[CMSAccountCoreFansListDurationOrder["CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_DESC"] = 2] = "CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_DESC";
})(CMSAccountCoreFansListDurationOrder = exports.CMSAccountCoreFansListDurationOrder || (exports.CMSAccountCoreFansListDurationOrder = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSAccountCoreFansListDurationOrder)
protobuf_1.proto3.util.setEnumType(CMSAccountCoreFansListDurationOrder, "spwn.account.v1.CMSAccountCoreFansListDurationOrder", [
    { no: 0, name: "CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_UNSPECIFIED" },
    { no: 1, name: "CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_ASC" },
    { no: 2, name: "CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_DESC" },
]);
/**
 * @generated from message spwn.account.v1.CMSCreator
 */
class CMSCreator extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        /**
         * @generated from field: spwn.account.v1.CMSCreatorRole role = 5;
         */
        this.role = CMSCreatorRole.CMS_CREATOR_ROLE_UNSPECIFIED;
        /**
         * クリエイターが所属しているテナント
         *
         * @generated from field: repeated spwn.account.v1.CMSTenantCore belonging_tenants = 6;
         */
        this.belongingTenants = [];
        /**
         * 権限があるブランド
         *
         * @generated from field: repeated spwn.account.v1.CMSBrandCore authorized_brands = 7;
         */
        this.authorizedBrands = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSCreator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSCreator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSCreator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSCreator, a, b);
    }
}
exports.CMSCreator = CMSCreator;
CMSCreator.runtime = protobuf_1.proto3;
CMSCreator.typeName = "spwn.account.v1.CMSCreator";
CMSCreator.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "role", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSCreatorRole) },
    { no: 6, name: "belonging_tenants", kind: "message", T: CMSTenantCore, repeated: true },
    { no: 7, name: "authorized_brands", kind: "message", T: CMSBrandCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.CMSCreatorCore
 */
class CMSCreatorCore extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSCreatorCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSCreatorCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSCreatorCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSCreatorCore, a, b);
    }
}
exports.CMSCreatorCore = CMSCreatorCore;
CMSCreatorCore.runtime = protobuf_1.proto3;
CMSCreatorCore.typeName = "spwn.account.v1.CMSCreatorCore";
CMSCreatorCore.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSBrand
 */
class CMSBrand extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 2;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 4;
         */
        this.slug = "";
        /**
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * @generated from field: string icon_thumbnail = 6;
         */
        this.iconThumbnail = "";
        /**
         * @generated from field: string cover_thumbnail = 7;
         */
        this.coverThumbnail = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSBrand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSBrand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSBrand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSBrand, a, b);
    }
}
exports.CMSBrand = CMSBrand;
CMSBrand.runtime = protobuf_1.proto3;
CMSBrand.typeName = "spwn.account.v1.CMSBrand";
CMSBrand.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "cover_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "belonging_tenant", kind: "message", T: CMSTenantCore },
]);
/**
 * @generated from message spwn.account.v1.CMSBrandCore
 */
class CMSBrandCore extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 2;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 4;
         */
        this.slug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSBrandCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSBrandCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSBrandCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSBrandCore, a, b);
    }
}
exports.CMSBrandCore = CMSBrandCore;
CMSBrandCore.runtime = protobuf_1.proto3;
CMSBrandCore.typeName = "spwn.account.v1.CMSBrandCore";
CMSBrandCore.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSTenant
 */
class CMSTenant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string tenant_firestore_id = 2;
         */
        this.tenantFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: repeated spwn.account.v1.CMSBrandCore owned_brands = 4;
         */
        this.ownedBrands = [];
        /**
         * @generated from field: repeated spwn.account.v1.CMSCreatorCore owned_creators = 5;
         */
        this.ownedCreators = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSTenant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSTenant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSTenant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSTenant, a, b);
    }
}
exports.CMSTenant = CMSTenant;
CMSTenant.runtime = protobuf_1.proto3;
CMSTenant.typeName = "spwn.account.v1.CMSTenant";
CMSTenant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "owned_brands", kind: "message", T: CMSBrandCore, repeated: true },
    { no: 5, name: "owned_creators", kind: "message", T: CMSCreatorCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.CMSTenantCore
 */
class CMSTenantCore extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string tenant_firestore_id = 2;
         */
        this.tenantFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSTenantCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSTenantCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSTenantCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSTenantCore, a, b);
    }
}
exports.CMSTenantCore = CMSTenantCore;
CMSTenantCore.runtime = protobuf_1.proto3;
CMSTenantCore.typeName = "spwn.account.v1.CMSTenantCore";
CMSTenantCore.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.IndividualTenantInfo
 */
class IndividualTenantInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 生年月日
         *
         * @generated from field: int64 date_of_birth = 1;
         */
        this.dateOfBirth = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new IndividualTenantInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndividualTenantInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndividualTenantInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(IndividualTenantInfo, a, b);
    }
}
exports.IndividualTenantInfo = IndividualTenantInfo;
IndividualTenantInfo.runtime = protobuf_1.proto3;
IndividualTenantInfo.typeName = "spwn.account.v1.IndividualTenantInfo";
IndividualTenantInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "date_of_birth", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.CorporationTenantInfo
 */
class CorporationTenantInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 会社名
         *
         * @generated from field: string corporation_name = 1;
         */
        this.corporationName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CorporationTenantInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorporationTenantInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorporationTenantInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CorporationTenantInfo, a, b);
    }
}
exports.CorporationTenantInfo = CorporationTenantInfo;
CorporationTenantInfo.runtime = protobuf_1.proto3;
CorporationTenantInfo.typeName = "spwn.account.v1.CorporationTenantInfo";
CorporationTenantInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "corporation_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountFan
 */
class CMSAccountFan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string email = 3;
         */
        this.email = "";
        /**
         * @generated from field: string memo = 4;
         */
        this.memo = "";
        /**
         * @generated from field: string avatar_url = 5;
         */
        this.avatarUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountFan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountFan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountFan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountFan, a, b);
    }
}
exports.CMSAccountFan = CMSAccountFan;
CMSAccountFan.runtime = protobuf_1.proto3;
CMSAccountFan.typeName = "spwn.account.v1.CMSAccountFan";
CMSAccountFan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountSubscribedPlan
 */
class CMSAccountSubscribedPlan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: int64 started_at = 3;
         */
        this.startedAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string thumbnail = 4;
         */
        this.thumbnail = "";
        /**
         * @generated from field: string firestore_id = 5;
         */
        this.firestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountSubscribedPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountSubscribedPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountSubscribedPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountSubscribedPlan, a, b);
    }
}
exports.CMSAccountSubscribedPlan = CMSAccountSubscribedPlan;
CMSAccountSubscribedPlan.runtime = protobuf_1.proto3;
CMSAccountSubscribedPlan.typeName = "spwn.account.v1.CMSAccountSubscribedPlan";
CMSAccountSubscribedPlan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountPurchasedGoods
 */
class CMSAccountPurchasedGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: int64 purchased_at = 3;
         */
        this.purchasedAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: string thumbnail = 4;
         */
        this.thumbnail = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountPurchasedGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountPurchasedGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountPurchasedGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountPurchasedGoods, a, b);
    }
}
exports.CMSAccountPurchasedGoods = CMSAccountPurchasedGoods;
CMSAccountPurchasedGoods.runtime = protobuf_1.proto3;
CMSAccountPurchasedGoods.typeName = "spwn.account.v1.CMSAccountPurchasedGoods";
CMSAccountPurchasedGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "purchased_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountPurchasedEventTickets
 */
class CMSAccountPurchasedEventTickets extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_name = 2;
         */
        this.eventName = "";
        /**
         * @generated from field: string ticket_name = 5;
         */
        this.ticketName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountPurchasedEventTickets().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountPurchasedEventTickets().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountPurchasedEventTickets().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountPurchasedEventTickets, a, b);
    }
}
exports.CMSAccountPurchasedEventTickets = CMSAccountPurchasedEventTickets;
CMSAccountPurchasedEventTickets.runtime = protobuf_1.proto3;
CMSAccountPurchasedEventTickets.typeName = "spwn.account.v1.CMSAccountPurchasedEventTickets";
CMSAccountPurchasedEventTickets.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "event_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ticket_purchased_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountCoreFan
 */
class CMSAccountCoreFan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.CMSAccountSubscribedPlan subscribed_plans = 2;
         */
        this.subscribedPlans = [];
        /**
         * @generated from field: repeated spwn.account.v1.CMSAccountPurchasedGoods purchased_goods = 3;
         */
        this.purchasedGoods = [];
        /**
         * @generated from field: repeated spwn.account.v1.CMSAccountPurchasedEventTickets purchased_event_tickets = 4;
         */
        this.purchasedEventTickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountCoreFan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountCoreFan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountCoreFan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountCoreFan, a, b);
    }
}
exports.CMSAccountCoreFan = CMSAccountCoreFan;
CMSAccountCoreFan.runtime = protobuf_1.proto3;
CMSAccountCoreFan.typeName = "spwn.account.v1.CMSAccountCoreFan";
CMSAccountCoreFan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_fan", kind: "message", T: CMSAccountFan },
    { no: 2, name: "subscribed_plans", kind: "message", T: CMSAccountSubscribedPlan, repeated: true },
    { no: 3, name: "purchased_goods", kind: "message", T: CMSAccountPurchasedGoods, repeated: true },
    { no: 4, name: "purchased_event_tickets", kind: "message", T: CMSAccountPurchasedEventTickets, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountPlan
 */
class CMSAccountPlan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string plan_id = 1;
         */
        this.planId = "";
        /**
         * @generated from field: string plan_name = 2;
         */
        this.planName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountPlan, a, b);
    }
}
exports.CMSAccountPlan = CMSAccountPlan;
CMSAccountPlan.runtime = protobuf_1.proto3;
CMSAccountPlan.typeName = "spwn.account.v1.CMSAccountPlan";
CMSAccountPlan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountGoods
 */
class CMSAccountGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * @generated from field: string goods_name = 2;
         */
        this.goodsName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountGoods, a, b);
    }
}
exports.CMSAccountGoods = CMSAccountGoods;
CMSAccountGoods.runtime = protobuf_1.proto3;
CMSAccountGoods.typeName = "spwn.account.v1.CMSAccountGoods";
CMSAccountGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountEvents
 */
class CMSAccountEvents extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_firestore_id = 1;
         */
        this.eventFirestoreId = "";
        /**
         * @generated from field: string event_name = 2;
         */
        this.eventName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountEvents().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountEvents().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountEvents().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountEvents, a, b);
    }
}
exports.CMSAccountEvents = CMSAccountEvents;
CMSAccountEvents.runtime = protobuf_1.proto3;
CMSAccountEvents.typeName = "spwn.account.v1.CMSAccountEvents";
CMSAccountEvents.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=cms_common_pb.js.map